import { datadogRum } from '@datadog/browser-rum';

export const InitMonitoringTool = () => {
	datadogRum.init({
		applicationId: 'e5463990-77a6-4172-9a33-d30632e1fdc9',
		clientToken: 'puba9a94b9995c5aa8a4ec89c6537303bd2',
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: 'us5.datadoghq.com',
		service: 'onboarding-digital',
		env: 'QA',
		// Specify a version number to identify the deployed version of your application in Datadog
		version: '1.8.6',
		sessionSampleRate: 100,
		sessionReplaySampleRate: 100,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		trackViewsManually: true,
		defaultPrivacyLevel: 'allow',
	});
};
